/* eslint-disable */
// @ts-ignore
// @ts-nocheck
import React, { useContext, SetStateAction } from "react";
import { ComboBox } from "@carbon/react";
import { MISC_TRANSLATIONS } from "../../translations/util";
import OrgContext from "../../store/orgContext";
import InlineLoader from "../loader/InlineLoader";
import FieldTooltip from "../tooltip/Tooltip";

export const ESOganisationDropdown = (props: {
  titleText?: string;
  orgsList?: { id: string; text: string }[];
  setXSSIOrg?: React.Dispatch<
    SetStateAction<{
      id: string;
      text: string;
    } | null>
  >;
  setOrg?: React.Dispatch<
    SetStateAction<{
      id: string;
      text: string;
    } | null>
  >;
  disabled?: boolean;
  org?: { id: string; text: string };
  placeholder?: string;
  className?: string;
  tooltiptext?: string;
}) => {
  const {
    titleText,
    orgsList = [],
    setOrg,
    setXSSIOrg,
    disabled = false,
    org,
    placeholder,
    className,
    tooltiptext,
  } = props;
  const { setSearchTerm, isLoading, noSearchResult } = useContext(OrgContext);

  return (
    <div className={`${className ? "ml-0" : "organisation-dropdown"} `}>
      <ComboBox
        className={className}
        titleText={titleText || MISC_TRANSLATIONS.ORG_DROPDOWN.label}
        data-cy="organisationDropdown"
        disabled={disabled}
        id={orgsList[0]?.id || "initial-combobox-id"}
        items={orgsList}
        initialSelectedItem={org}
        onChange={(item: { selectedItem: { id: string; text: string } }) => {
          if (setOrg) setOrg(item.selectedItem);
          if (setXSSIOrg) setXSSIOrg(item.selectedItem);
        }}
        shouldFilterItem={({ inputValue, item: { text } }) => {
          setSearchTerm(inputValue.split("(")[0].trim());
          return text
            .split("(")[0]
            .trim()
            .toLowerCase()
            .includes(inputValue.split("(")[0].trim().toLowerCase());
        }}
        itemToElement={(item: { id: string; text: string }) => item.text}
        itemToString={(item: { id: string; text: string }) =>
          item ? item.text : ""
        }
        placeholder={placeholder || MISC_TRANSLATIONS.ORG_DROPDOWN.placeholder}
      />
      {/* Loading indicator */}
      {isLoading && (
        <div className="orgList-loader">
          <InlineLoader description="Loading Organisations" />
        </div>
      )}

      {/* If no results for searched term found */}
      {noSearchResult && (
        <div className="orgList-loader no-result-container">
          <div className="no-result">
            <div className="no-result-text">
              <div className="data-icon flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="w-10 h-20 mr-2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                  />
                </svg>
                No match found
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ESOganisationDropdown;
